<rcl-modal
	id="biometrics-privacy-rcl-modal"
	[show]="showBiometricsPrivacyModal"
	[mobileFullScreen]="false"
	[attr.aria-hidden]="!showBiometricsPrivacyModal"
	(onClose)="closeModal()"
>
	<rcl-modal-content id="biometrics-privacy-rcl-modal__content" [attr.tabindex]="0" *ngIf="!showSecondaryContent" tabindex="0">
		<rcl-modal-title id="biometrics-privacy-rcl-modal__content__title">
			{{ bundle && bundle['data.privacy.modal.header'] }}
		</rcl-modal-title>
		<span id="biometrics-privacy-rcl-modal__content__message" [innerHTML]="contentMessage()"></span>
		<p id="biometrics-privacy-rcl-modal__content__lastsentence">
			{{ bundle && bundle['data.privacy.modal.lastsentence'] }}
			<a
				id="biometrics-privacy-rcl-modal__content__lastsentence__link"
				[href]="this.privacyPolicyUrl()"
				class="rcl-text-link"
				tabindex="0"
				target="_blank"
        rel="noopener"
			>
				{{ bundle && bundle['data.privacy.modal.link'] }}
			</a>
		</p>
	</rcl-modal-content>

	<rcl-modal-content id="biometrics-privacy-rcl-modal__secondary-content" [attr.tabindex]="0" *ngIf="showSecondaryContent" tabindex="0">
		<rcl-modal-title id="biometrics-privacy-rcl-modal__secondary-content__title">
			{{ bundle && bundle['second.data.privacy.modal.header'] }}
		</rcl-modal-title>
		<span id="biometrics-privacy-rcl-modal__secondary-content__message" [innerHTML]="secondModalContent()"></span>
		<p id="biometrics-privacy-rcl-modal__secondary-content__lastsentence">
			{{ bundle && bundle['data.privacy.modal.lastsentence'] }}
			<a
				id="biometrics-privacy-rcl-modal__secondary-content__lastsentence__link"
				[href]="this.privacyPolicyUrl()"
				class="rcl-text-link"
				tabindex="0"
				target="_blank"
        rel="noopener"
			>
				{{ bundle && bundle['data.privacy.modal.link'] }}
			</a>
		</p>
	</rcl-modal-content>

	<rcl-modal-actions id="biometrics-privacy-rcl-modal__actions">
		<button id="biometrics-privacy-rcl-modal__actions__close" (click)="closeModal()" class="rcl-button-secondary">
			{{ bundle && bundle['button.close'] }}
		</button>
	</rcl-modal-actions>
</rcl-modal>
